import sanitizeHtml from "sanitize-html"

export const sanitizeInput = (input) => {
  const sanitizeString = (str) =>
    sanitizeHtml(str, {
      allowedTags: [],
      allowedAttributes: {},
    })

  if (typeof input === "string") {
    return sanitizeString(input)
  }

  if (Array.isArray(input)) {
    return input.map((element) =>
      typeof element === "string" ? sanitizeString(element) : element
    )
  }

  return input
}

export const isUrlPattern = (url) => {
  const pattern = new RegExp(
    /(\b(https?|ftp|file):\/\/|www\.|[a-zA-Z0-9-]+\.[a-zA-Z]{2,})\S*/gi
  )
  return pattern.test(url)
}
